export const UPDATE_GLOBAL_UPLOAD_MODAL_PROPS = 'UPDATE_GLOBAL_UPLOAD_MODAL_PROPS';